module.exports = __webpack_public_path__ + "static/media/boeuf-bourguignon.147dc999.png";